<template>
	<div class="container">
		<div v-if="this.data.show_title">
			<h3>{{ this.data.title }}</h3>
		</div>
		<div class="row mt-1 g-3">
			<image-box v-for="(imagebox, index) in ItemQuantity"
					   :key="index"
					   :image="imagebox"
					   class="col-12"
					   :class="itemSize"
			/>
			<span class="mt-0" v-html="this.data?.data?.editorBody"></span>
		</div>

	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import ImageBox from "../../../Components/ImageBox/ImageBox.vue";
import {ImageSectionDataInterface} from "../Interfaces/ImageSectionDataInterface";


export default defineComponent({
	name: "ImageBoxPageSection",
	components: {ImageBox},
	props: {
		data: {
			type: Object as PropType<ImageSectionDataInterface>,
			required: true,
			default: {}
		}
	},
	computed: {
		ItemQuantity() {
			const {data: {images, quantity}} = this.data
			return (images ?? []).slice(0, quantity);
		},
		itemSize() {
			const quantity = this.data.data.quantity ?? 4;
			const classSize = Math.floor(12 / quantity);

			return `col-lg-${classSize} col-md-${classSize * 2}`;
		}
	}
});
</script>

<style scoped>
</style>
